module.exports = __webpack_public_path__ + "img/skull_2_bj.d0ce46d3.png";